import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AuthenticationResponse, AuthenticationResult} from '@flowmaps-com/flowmaps-typescriptmodels';
import {firstValueFrom, timeout} from 'rxjs';

import {environment} from '../../environments/environment';
import {AuthService} from './auth.service';

const reboundLoginParameter = 'reboundLogin';

@Injectable()
export class ReboundLoginService {
    constructor(private http: HttpClient, private authService: AuthService) {
    }

    initialise(): Promise<void> {
        if (environment.production || this.requestedUser() !== 'admin') {
            return Promise.resolve();
        }
        return firstValueFrom(this.http.get<AuthenticationResponse>(
            environment.apiProtocol + environment.apiDomain + '/api/rebound/login/admin',
            {withCredentials: true}
        ).pipe(timeout(2_000))).then(response => {
            if (response.result !== AuthenticationResult.SUCCESS) {
                return;
            }
            if (this.authService.startSession(response)) {
                this.cleanLoginUrl();
            }
        }).catch(error => {
            console.warn('Local Rebound admin login is unavailable; continuing signed out.', error);
        });
    }

    private requestedUser(): string | null {
        return new URLSearchParams(window.location.search).get(reboundLoginParameter)?.trim() || null;
    }

    private cleanLoginUrl() {
        const url = new URL(window.location.href);
        url.searchParams.delete(reboundLoginParameter);
        window.history.replaceState(window.history.state, document.title, `${url.pathname}${url.search}${url.hash}`);
    }
}
